import {useEffect, useRef, useState} from "react";


const NumberIncrement = (props) => {
    const [count, setCount] = useState(1);
    const targetRef = useRef(null);

    const startCounting = () => {
        let startTime;
        const duration = 2000; // 2 seconds
        const step = () => {
            const currentTime = Date.now();
            const progress = currentTime - startTime;
            const increment = Math.floor((progress / duration) * props.target);

            if (progress < duration) {
                setCount(increment);
                requestAnimationFrame(step);
            } else {
                setCount(props.target);
            }
        };

        startTime = Date.now();
        requestAnimationFrame(step);
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        startCounting();
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 1 } // Adjust the threshold as needed
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, []);

    const numberWithCommas = count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return (
            <span ref={targetRef} className={"text-tertiary-900 text-[40px] font-semibold"}>{numberWithCommas}+</span>
    );
};



export default function StatsCard(props){

    const [booksPurchased, setBooksPurchased] = useState(50000)
    const [testGiven, setTestGiven] = useState(12000)
    const [students, setStudents] = useState(70)



    return(
        <div className={"flex justify-center md:mb-[140px] mb-[40px]  items-center w-full "}>

            <div className={"flex self-center w-4/6 md:flex-row border-[1px] mobile:flex-col justify-between md:px-32 gap-2  lg:items-center bg-white rounded-[16px] drop-shadow-md p-4"}>

                <div className={"flex flex-1 flex-col md:border-r-2 mobile:pb-8 md:pb-0 md:border-b-0 mobile:border-b-2  justify-center items-center"}>
                    <NumberIncrement target={booksPurchased} />
                    <span className={"mobile:text-[17px] text-gray-500 text-center"}>
                        Subscribers

                    </span>
                </div>

                <div className={"flex flex-1 flex-col mobile:mt-4 md:mt-0 md:border-r-2 md:border-b-0 sm:pb-4 mobile:border-b-2  mobile:pb-6 md:pb-0 justify-center items-center"}>
                    <NumberIncrement target={testGiven} />
                    <span className={"mobile:text-[17px] text-gray-500 text-center"}>Test Passed</span>
                </div>
                <div className={"flex flex-1 flex-col mobile:pb-4 md:pb-0   justify-center items-center"}>
                    <NumberIncrement target={students} />
                    <span className={"mobile:text-[17px] text-gray-500 text-center"}>Countries</span>
                </div>




            </div>
        </div>
    )
}
